export class DateDetail{
    latestDate:any
}